import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import addReadWriteRecipients from './addReadWriteRecipients';
import resolveAllUnresolvedRecipients from './resolveAllUnresolvedRecipients';
import isValidEmailAddress from '../utils/isValidEmailAddress';
import parseSuspectedDisplayNameEmailAddress from '../utils/parseSuspectedDisplayNameEmailAddress';
import { action } from 'satcheljs/lib/legacy';

const SEPARATOR_REGEX = new RegExp(';|\\n|\\r\\n', 'g');

export default action('parsePastedTextForRecipients')(function parsePastedTextForRecipients(
    recipientWell: RecipientWellWithFindControlViewState,
    inputText: string
) {
    let recipientList = inputText.split(SEPARATOR_REGEX);
    recipientList.forEach(element => {
        let trimmedElement = element.trim();
        if (trimmedElement.length > 0) {
            // try to parse out a suspected name + email address combo
            let result = parseSuspectedDisplayNameEmailAddress(trimmedElement);
            addReadWriteRecipients(recipientWell, [
                {
                    isValid: isValidEmailAddress(result.EmailAddress.EmailAddress),
                    newPersona: result,
                    newEmailAddress: null,
                },
            ]);
        }
    });

    resolveAllUnresolvedRecipients(recipientWell, recipientWell.recipients);
});
